import RouteName from '@/models/enums/RouteName'

export default [
    {
    path: '/staff',
    name: RouteName.Staff,
    component: () => import('../../../pages/Staff/StaffList.vue'),
    permissions: ['crm.users.view'],
    meta: {
      breadcrumb: {
        label: 'Сотрудники',
        parent: RouteName.Settings,
      },
    },
  },
  {
    path: '/staff/create',
    name: 'user-create',
    component: () => import('../../../pages/Staff/StaffForm.vue'),
    permissions: ['crm.users.edit'],
    meta: {
      breadcrumb: {
        label: 'Новый',
        parent: RouteName.Staff,
      },
    },
  },
  {
    path: '/staff/:id',
    name: 'user-edit',
    component: () => import('../../../pages/Staff/StaffForm.vue'),
    props: { isEdit: false },
    permissions: ['crm.users.edit'],
    meta: {
      breadcrumb: {
        label: 'Редактирование',
        parent: RouteName.Staff,
      },
    },
  },
]
